module.exports = {"horsSportGeorgia":"საქართველოს საცხენოსნო სპორტის ფედერაცია","aboutUs":"ჩვენს შესახებ","news":"ახალი ამბები","history":"ისტორია","clubsAndUnions":"მოქმედი კლუბები","tourismAndAdventure":"ტურიზმი","contactUs":"დაგვიკავშრდით","aboutHorses":"ცხენების შესახებ"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EN-vers/menuNameJSON/geHeader.json
// module id = sFne
// module chunks = 0